export const PREVIOUS_SSO_SOURCE = "PREVIOUS_SSO_SOURCE"

export const SSO_NAME_MAPPING = {
  clever: "Clever",
  classlink: "Classlink",
  schoology: "Schoology"
}
